module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-page-sponsors u-pad-y-1"
  }, [_c('div', {
    staticClass: "c-page--container c-marg--before-footer u-relative"
  }, [_c('app-title', {
    staticClass: "c-big-title",
    attrs: {
      "logo": _vm.contentGlobal.secondaryLogo,
      "title": _vm.contentPage.title
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "u-relative u-vacuum"
  }, _vm._l((_vm.contentGlobal.partners), function(sponsor) {
    return _c('div', {
      key: sponsor.id,
      staticClass: "u-inline-block u-valign-top t-text--md u-w2of4 u-align-left u-marg-b-xxl u-pad-a-md u-w3of4@lg u-fit-w@md u-marg-b-md@md"
    }, [_c('img', {
      staticClass: "c-page-sponsors__logo u-fit-w u-marg-b-lg",
      attrs: {
        "src": sponsor.img,
        "alt": sponsor.name
      }
    }), _vm._v(" "), _c('h2', {
      staticClass: "u-marg-t-sm t-text--sm t-text--bold u-uppercase",
      domProps: {
        "innerHTML": _vm._s(sponsor.name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "o-content t-text--sm u-marg-t-xs u-line-height--lg u-color--gray-blue u-marg-b-md",
      domProps: {
        "innerHTML": _vm._s(sponsor.content)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "u-align-right u-align-center@md"
    }, [(sponsor.register) ? _c('app-btn', {
      staticClass: "u-marg-r-sm u-valign-middle c-btn--secondary u-marg-b-xs@sm u-marg-x-xxs@sm",
      on: {
        "click": function($event) {
          _vm.openModalRegister(sponsor.register.typeSlug)
        }
      }
    }, [_c('span', {
      staticClass: "c-register-btn-icon__container u-inline-block"
    }, [_c('img', {
      staticClass: "c-register-btn-icon__img u-absolute u-pos-l u-pos-y-center",
      attrs: {
        "src": require("../../../assets/icon/icon-register--competition.png")
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(sponsor.register.label)
      }
    })]) : _vm._e(), _vm._v(" "), _c('app-btn', {
      staticClass: "u-marg-x-xxs@sm u-marg-b-xs@sm",
      attrs: {
        "to": sponsor.url,
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.contentGlobal.taxonomies.actions.visitWebsite)
      }
    })])], 1)])
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1538c194"}!./src/scripts/components/page-sponsors/template.html
// module id = 886
// module chunks = 0